module.exports = __webpack_public_path__ + "static/media/aacom-white.3e9d90e3.svg";